var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnInstall1Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8361_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9705 8.33332C17.326 10.2011 17.0726 12.1428 16.2527 13.8348C15.4327 15.5268 14.0957 16.8667 12.4645 17.6311C10.8334 18.3955 9.00684 18.5381 7.28937 18.0353C5.5719 17.5325 4.06736 16.4145 3.02666 14.8678C1.98597 13.3212 1.47202 11.4394 1.57052 9.53615C1.66903 7.63294 2.37403 5.8234 3.56796 4.4093C4.7619 2.9952 6.3726 2.06202 8.13145 1.76537C9.8903 1.46872 11.691 1.82654 13.2332 2.77916",
    stroke: "#00A63E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00586 9.16671L9.34115 11.6667L17.1255 3.33337",
    stroke: "#00A63E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8361_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6823,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnInstall1Icon);
export default __webpack_public_path__ + "static/media/on_install_1_icon.cbdf73aeefdd278cdd1ab4fe65d25f9c.svg";
export { ForwardRef as ReactComponent };